
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';

import SubmitButton from '@/components/controls/submit-button.vue';
import Dropdown, { DropdownItems } from '@/components/controls/dropdown.vue';

import { ClinicalTrainingEventsActions } from '@/store/modules/clinical-training-events/types';
import { ClinicalTrainingEventStatus } from '@/store/modules/clinical-training-events/clinical-training-event';

export default Vue.extend({
  name: 'ClinicalTrainingEventsFilter',
  components: {
    SubmitButton,
    Dropdown,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    selectedItems: {
      type: Array,
      default: () => [] as number[],
    },
  },
  computed: {
    ...mapGetters('user/profile', ['isSuperAdmin', 'isAdmin']),
    dropdownItems() {
      const items: DropdownItems = {};
      
      items.reset = {
        label: this.$t('Reset Filters'),
        icon: 'close',
      };
      
      if ((this.isSuperAdmin || this.isAdmin) && this.selectedItems && this.selectedItems.length) {
        items.restore = {
          hasTopBorder: true,
          label: this.$t('Restore'),
          count: this.selectedItems.length,
          disabled: !this.selectedItems.length,
        };

        items.remove = {
          label: this.$t('Delete'),
          count: this.selectedItems.length,
          disabled: !this.selectedItems.length,
        };
      }
      
      return items;
    },
  },
  data() {
    return {
      availableStatuses: {
        [ClinicalTrainingEventStatus.Inactive]: this.$t('Inactive'),
        [ClinicalTrainingEventStatus.Active]: this.$t('Active'),
      },
      search: '',
      status: '',
    };
  },
  methods: {
    ...mapActions('clinicalTrainingEvents', {
      bulkDeleteEvents: ClinicalTrainingEventsActions.BULK_DELETE,
      bulkRestoreEvents: ClinicalTrainingEventsActions.BULK_RESTORE,
    }),
    initFilters(): void {
      this.search = this.$router.currentRoute.query.search || '';
      this.status = this.$router.currentRoute.query.status || '';
    },
    applyFilters(): void {
      const { sort, direction, ...queryParams } = this.$route.query;

      this.$router.push({
        params: {
          page: 1,
        },
        query: {
          ...queryParams,
          search: this.search,
          status: this.status,
        },
      });
    },
    handleDropdownClick(action: string): void {
      if ('reset' === action) {
        this.$router.push({
          params: {
            page: 1,
          },
          query: {},
        });
      }

      if ('remove' === action) {
        const answer = window.confirm(this.$t('Do you really want to delete selected clinical training events?'));
        if (answer) {
          this.bulkDeleteEvents({ ids: this.selectedItems });
        }
      }

      if ('restore' === action) {
        const answer = window.confirm(this.$t('Do you really want to restore selected clinical training events?'));
        if (answer) {
          this.bulkRestoreEvents({ ids: this.selectedItems });
        }
      }
    },
  },
  created(): void {
    this.initFilters();
  },
  watch: {
    $route(): void {
      this.initFilters();
    },
  },
});
